/**
 * cXML Template Utilities
 * Contains functions to build cXML responses for various punchout scenarios
 */

/**
 * Builds an empty cXML PunchOutOrderMessage for returning to procurement system
 * without any cart items (Total = 0). Used when user clicks "Return Items" 
 * button on popup landing page without completing a purchase.
 * 
 * @param {string} orderReferenceId - Unique order reference ID (used as payloadID)
 * @param {string} buyerCookie - Buyer cookie from the original punchout session request
 * @returns {string} Empty cXML PunchOutOrderMessage with zero total
 */
export const buildEmptyCxml = (orderReferenceId, buyerCookie) => {
    const timestamp = new Date().toISOString();
    
    return `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.011/cXML.dtd">
<cXML payloadID="${orderReferenceId}" timestamp="${timestamp}" version="1.2.009" xml:lang="EN">
    <Header>
        <From>
            <Credential domain="DUNS">
                <Identity>1095276680000</Identity>
            </Credential>
        </From>
        <To>
            <Credential domain="Networkid">
                <Identity>PunchoutResponse</Identity>
            </Credential>
        </To>
        <Sender>
            <Credential domain="connect.punchout2go.com">
                <Identity>PunchoutResponse</Identity>
                <SharedSecret></SharedSecret>
            </Credential>
            <UserAgent>Sysco Punchout</UserAgent>
        </Sender>
    </Header>
    <Message>
        <PunchOutOrderMessage>
            <BuyerCookie>${buyerCookie}</BuyerCookie>
            <PunchOutOrderMessageHeader operationAllowed="create">
                <Total>
                    <Money currency="USD">0</Money>
                </Total>
            </PunchOutOrderMessageHeader>
        </PunchOutOrderMessage>
    </Message>
</cXML>`;
};
